import { useCallback } from 'react';

import { getBaseUrl } from '@order/utils';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Opens the external Stripe checkout session url.
 * On web, replaces the current page, the redirect will re-open the bag from scratch.
 */
export const useOpenCheckoutSession = () => {
  return useCallback(async (url: string) => {
    window.location.replace(url);
  }, []);
};

// ─── Constants ───────────────────────────────────────────────────────────────

export const redirectUrl = `${getBaseUrl()}/bag`;
